<template>
	<ul class="collapsible collapsible-element">
		
				<div class="switch" v-if="checkDefault" v-show="false" data-label="Default State">
					<label>
						Closed
						<input type="checkbox" v-model="isActive">
						<span class="lever"></span>
						Opened
					</label>
				</div>
		<li :class="[isOpen ? 'active' : '', checkDefault && isActive ? 'active' : '']">
			<div class="collapsible-header">
				<slot name="header">
					<i class="material-icons">filter_drama</i> Item Header
				</slot>
			</div>
      <div class="collapsible-body" :class="bodyClasses">
				<slot name="body"></slot>
			</div>
		</li>
	</ul>
</template>
<script>
import M from 'materialize-css'
export default {
    name: 'collapsibleComponent',
		props:{
			checkDefault: {
				type: Boolean
			},
			index:{
				type: [Number, Boolean],
				default: false
			},
			isOpen: {
				type: [Boolean],
				default: false,
			},
			bodyClasses:{
				type: String,
			}
		},
		data () {
			return  {
				historyObeject:null,
				isActive:true,
				instance: null,
				options: {
					onOpenEnd: (e)=> {
					  console.log()
					this.checkDefault ?	this.isActive = e.classList.length > 0 : ''
					},
					onCloseEnd: (e)=> {
					  console.log()
					this.checkDefault ?	this.isActive = e.classList.length > 0 : ''
					}
				}
			}
		},
		watch:{
			isActive: function(nV) {
					let newObject = localStorage.getItem('localSettings')
					let kk = JSON.parse(newObject)
					let storageObject = {
						index: this.index,
						active: this.isActive
					}
					this.$set(kk[this.$route.name.toLowerCase()],`ele${this.index}`, storageObject)
					//this.historyObeject[this.$route.name.toLowerCase()][] = storageObject
					localStorage.setItem('localSettings', JSON.stringify(kk))
					this.historyObeject = kk
					
				
			}
		},
		mounted () {
			setTimeout(() => {
				this.initCollapsibleComponent()
			}, 400);
			if (this.checkDefault) {
				if(this.historyObeject) {
					this.historyObeject[this.$route.name.toLowerCase()] && 	this.historyObeject[this.$route.name.toLowerCase()][`ele${this.index}`]
					 ? this.isActive = 	this.historyObeject[this.$route.name.toLowerCase()][`ele${this.index}`].active
					 : this.isActive = true
				}
				let mainOne = localStorage.getItem('localSettings')
				if(mainOne) {
					let allOfThem = JSON.parse(mainOne)
					this.historyObeject = allOfThem
					if(this.historyObeject[this.$route.name.toLowerCase()] && this.historyObeject[this.$route.name.toLowerCase()][`ele${this.index}`]) {
						this.isActive = this.historyObeject[this.$route.name.toLowerCase()][`ele${this.index}`].active
					} else {
						this.$_newHistoryObject()
					}

				}
				else {
					if(this.checkDefault) {
					let storageBucket = {
						name:this.$route.name,
						path: this.$route.path,
					}
					let storageObject = {
						index: this.index,
						active: this.isActive
					}
			
						let me = {}
						me['ele'+this.index] = storageObject
						storageBucket[this.$route.name.toLowerCase()] = me
						this.historyObeject = storageBucket
						localStorage.setItem('localSettings', JSON.stringify(storageBucket))
					}
				}
			}
		},
		methods: {
			$_newHistoryObject () {
				let storageBucket = {
						name:this.$route.name,
						path: this.$route.path,
					}
					let storageObject = {
						index: this.index,
						active: this.isActive
					}
			
						let me = {}
						me['ele'+this.index] = storageObject
						storageBucket[this.$route.name.toLowerCase()] = me
						let newStorageObject = {...this.historyObeject, ...storageBucket}
						localStorage.setItem('localSettings', JSON.stringify(newStorageObject))
			},
			initCollapsibleComponent () {
				let elems = this.$el
    		this.instance = M.Collapsible.init(elems, this.options)
			}
		}

}
</script>
<style scoped lang="scss">
.collapsible {
		border-radius: 6px;
    overflow: hidden;
		.active {
			.collapsible-header{
					&::after {
							content: 'expand_less';
						}
					}
				}
		.collapsible-header{
			padding: 8px 16px;
			position: relative;
			&::after {
					content: 'expand_more';
					position: absolute;
					right: 16px;
					font-family: 'Material Icons Outlined';
					font-size: 24px;
					top: 50%;
					transform: translateY(-50%);
			}
		}
}
.collapsible-body {
	border-bottom: none;
	&.padding-16 {
		padding: 16px;
	}
}
</style>